/*!
 * devextreme-react
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

var elementPropNames = ['style', 'id'];
var classNamePropName = 'className';
var refPropName = ['dropZone', 'dialogTrigger'];
function isIgnoredProp(name) {
    return name === 'children' || name === classNamePropName || elementPropNames.includes(name);
}
function getRefElement(value) {
    var _a;
    if (value === null || value === void 0 ? void 0 : value.current) {
        if ((_a = value.current.instance) === null || _a === void 0 ? void 0 : _a.element()) {
            return value.current.instance.element();
        }
        return value.current;
    }
    return value;
}
function separateProps(props, defaultsProps, templateProps) {
    templateProps = templateProps || [];
    var defaults = {};
    var options = {};
    var templates = {};
    var knownTemplates = {};
    templateProps.forEach(function (value) {
        knownTemplates[value.component] = true;
        knownTemplates[value.render] = true;
    });
    Object.keys(props).forEach(function (key) {
        var defaultOptionName = defaultsProps ? defaultsProps[key] : null;
        var value = props[key];
        if (isIgnoredProp(key)) {
            return;
        }
        if (defaultOptionName) {
            defaults[defaultOptionName] = value;
            return;
        }
        if (knownTemplates[key]) {
            templates[key] = value;
            return;
        }
        if (refPropName.includes(key)) {
            options[key] = getRefElement(value);
            return;
        }
        options[key] = props[key];
    });
    return { options: options, defaults: defaults, templates: templates };
}
function getClassName(props) {
    return props[classNamePropName];
}
export { elementPropNames, getClassName, separateProps, };
